export { default } from "./ChallengesTeacherTab";
